import React from 'react'

import WhatsAppWidget from 'react-whatsapp-widget'
import 'react-whatsapp-widget/dist/index.css'

const Whatsapp = () => {
  return <WhatsAppWidget phoneNumber='+919000090403' message='Hello! 👋🏼 Welcome To Hive Employee Transportation And Cab Services, What can we do for you?' />
}

export default Whatsapp